/* Timo istorijos tekstas, lietuvių kalba.
 *
 * ŠITAS FAILAS IR YRA REDAGUOJAMAS. Kiekvieną eilutę Timo ištaria balsu,
 * todėl rašyk taip, kaip turi skambėti, o ne taip, kaip turi atrodyti.
 *
 * Kaip tai groja: istorija turi penkis skyrius. Kiekvienas skyrius yra
 * VIENAS teksto į kalbą iškvietimas, sudėtas taip
 *     [pagyrimas arba padrąsinimas už praeitą žodį] + [skyrius] + [kvietimas]
 * tad visa istorija kainuoja penkis iškvietimus. Tai svarbu: TTS sluoksnis
 * leidžia penkis iškvietimus per šešiasdešimt sekundžių, o vieną iškvietimą
 * riboja iki 2500 simbolių ir tyliai nukerta viską, kas ilgiau. Laikyk
 * kiekvieną skyrių tarp 500 ir 700 simbolių, ir visa eilutė bus saugi.
 *
 * Du priedainiai kartojasi žodis į žodį sąmoningai. Vaikas prisideda
 * trečią kartą juos išgirdęs, o prisidėti ir yra visa esmė:
 *     Timo klauso. Timo laukia. Timo padeda.
 *     Sakykime kartu, tarė Timo.
 * Nekaitaliok jų dėl grožio. Vienodumas čia yra privalumas.
 *
 * Keturi tiksliniai žodžiai yra tie, kuriuos prašoma pasakyti VAIKO. Jie
 * parinkti kaip lengviausi savo skyriaus žodžiai, o ne kaip gražiausi:
 * namai, uoga, vanduo, medus. Visi yra dviskiemeniai, be r, l ir š, ir
 * prasideda ankstyvais garsais. Nekeisk jų į gražesnius.
 *
 * Angliškame originale antras ir ketvirtas žodžiai buvo nut ir happy.
 * Lietuviškai riešutas ir laimingas per sunkūs, todėl tie skyriai
 * perrašyti su uoga ir medumi.
 */

const storyLt = {
  'story.title': 'Timo žaliasis miškas',
  // Timo hands the telling over to Hoppy, then the recorded story plays.
  'story.handoff': "Ei! Paprašysiu savo draugo Hopio, kad ją papasakotų.",

  // ==== Penki skyriai ====

  // 1 skyrius: kas yra Timo
  'story.ch1':
    'Timo gyvena dideliame žaliame miške. Timo yra mažas. Timo turi minkštą dryžuotą uodegą. ' +
    'Timo turi dideles apvalias ausis. Didelės ausys puikiai girdi. Miške gyvena daug gyvūnų. ' +
    'Ten yra didelė lėta meška. Ten yra mažas paukštelis. Ten yra dvi alkanos voverės. ' +
    'Visi kalba vienu metu. Būna labai triukšminga. Bet Timo nekalba pirmas. ' +
    'Timo klauso. Timo laukia. Timo padeda. Miškas yra jo namai. Jis pažįsta kiekvieną medį. ' +
    'Jis pažįsta kiekvieną šiltą akmenį. Jis žino geriausią vietą, kur sėdėti ir žiūrėti į mėnulį. ' +
    'Čia jo namai, ir čia jam gera.',

  // 2 skyrius: dvi voverės
  'story.ch2':
    'Vieną dieną dvi voverės rado uogą. Tai buvo viena didelė saldi uoga. ' +
    'Abi voverės norėjo tos uogos. Jos traukė ją į vieną pusę. Jos traukė ją į kitą pusę. ' +
    'Jos nepasakė nė vieno žodžio. Jos tik traukė ir traukė. Tada atėjo Timo ir atsisėdo šalia. ' +
    'Timo klauso. Timo laukia. Timo padeda. Tada Timo tarė, pasakykite, ko norite. ' +
    'Sakykime kartu, tarė Timo. Pirma voverė pasakė, aš noriu uogos. ' +
    'Antra voverė pasakė, aš irgi noriu uogos. Dabar mes žinome, tarė Timo. ' +
    'Uoga yra viena, bet jos užteks abiem. Voverės padalijo uogą pusiau. Abi buvo linksmos.',

  // 3 skyrius: mažas paukštelis, visos istorijos širdis
  'story.ch3':
    'Paskui atskrido mažas paukštelis. Jis atsitūpė ant žemos šakos. ' +
    'Jam buvo karšta ir jis norėjo gerti. Paukštelis kažko norėjo, bet žodis niekaip neišėjo. ' +
    'Jis pravėrė snapelį. Bet nieko nepasakė. Jis pažiūrėjo žemyn į savo kojytes. ' +
    'Niekas jo neskubino. Timo klauso. Timo laukia. Timo padeda. ' +
    'Timo tyliai sėdėjo šalia ilgą ramią minutę. Tada Timo pats pasakė žodį, lėtai ir švelniai. ' +
    'Vanduo. Sakykime kartu, tarė Timo. Paukštelis pabandė. Van. Jis pabandė dar kartą. ' +
    'Vanduo. Jis pasakė! Jis pasakė vanduo! Visas žalias miškas plojo mažam paukšteliui.',

  // 4 skyrius: miškas pasikeičia, Timo išgirsta vaikus
  'story.ch4':
    'Po tos dienos miškas tapo kitoks. Kai meška norėjo medaus, ji pasakė medus. ' +
    'Kai voverės norėjo žaisti, jos pasakė žaisti. Kai paukštelis norėjo gerti, jis pasakė vanduo. ' +
    'Niekas nebetraukė. Niekas nebestumdė. Dabar visi turėjo savo žodį. ' +
    'Medus, vanduo, žaidimas, visiems užteko žodžių. Timo buvo labai gera. Visam miškui buvo gera. ' +
    'Vieną vakarą Timo atsisėdo ant savo šilto akmens ir žiūrėjo į mėnulį. Ir išgirdo kai ką naujo. ' +
    'Toli toli, už medžių, buvo vaikai. Jie turėjo daug ką pasakyti. Bet žodžiai buvo užstrigę viduje. ' +
    'Timo sėdėjo labai tyliai. Timo galvojo apie mažą paukštelį.',

  // 5 skyrius: Timo ateina pas vaiką
  'story.ch5':
    'Rytą Timo pasiėmė mažą krepšį. Jis atsisveikino su didele lėta meška. ' +
    'Jis atsisveikino su dviem voverėmis. Jis atsisveikino su mažu paukšteliu. ' +
    'Paukštelis sudainavo jam dainą, ir toje dainoje buvo daug žodžių. ' +
    'Tada Timo išėjo iš didelio žalio miško. Jis ėjo labai labai ilgai. ' +
    'Ir visą kelią atidžiai klausėsi. Timo klauso. Timo laukia. Timo padeda. ' +
    'Ir vieną dieną, toli nuo miško, jis išgirdo tave. Tai štai aš čia. ' +
    'Dabar aš jau ne miške. Aš esu čia, su tavimi. ' +
    'Ir tu turi daug ką pasakyti. Labai norėčiau tai išgirsti.',

  // ==== Keturi kvietimai: jais baigiasi skyrius, po jų vaikas kalba ====
  'story.invite1': 'Žalias miškas yra Timo namai. Sakyk namai kartu su manimi.',
  'story.invite2': 'Viena didelė uoga dviem draugams. Sakyk uoga kartu su manimi.',
  'story.invite3': 'Mažas paukštelis rado savo žodį. Sakyk vanduo kartu su manimi.',
  'story.invite4': 'Meška pasakė, ko nori. Sakyk medus kartu su manimi.',

  // ==== Keturi tiksliniai žodžiai: juos sako vaikas ====
  'story.word1': 'namai',
  'story.word2': 'uoga',
  'story.word3': 'vanduo',
  'story.word4': 'medus',

  // ==== Keturi pagyrimai: kai vaikas pasako žodį ====
  'story.celebrate1': 'Namai! Tu pasakei, ir mano didelės ausys net sujudėjo.',
  'story.celebrate2': 'Uoga! Kaip gražiai pasakei. Abi voverės tau moja.',
  'story.celebrate3': 'Vanduo! Tu pasakei lygiai kaip paukštelis. Aš tavimi labai didžiuojuosi.',
  'story.celebrate4': 'Medus! Koks saldus žodis, ir tu jį pasakei.',

  // ==== Keturi padrąsinimai: kai vaikas nieko nesako ====
  'story.encourage1': 'Namai, namai, žalias miškas yra mano namai. Eime susipažinti su mano draugais.',
  'story.encourage2': 'Uoga, uoga, viena didelė saldi uoga. O dabar eime susipažinti su mažu paukšteliu.',
  'story.encourage3': 'Vanduo, vanduo, vienas gurkšnis šalto vandens. Eime pažiūrėti, kas nutiko toliau.',
  'story.encourage4': 'Medus, medus, saldus meškos medus. O dabar eime kartu į pabaigą.',

  'story.ending':
    'Grįžk rytoj, ir aš papasakosiu tau apie mešką ir pačią paskutinę uogą. Labanakt, mano drauge.',
};

export default storyLt;
